import { RouteEnum } from '@enum/route.enum';

import { ApplicationSetupConnectorsPage } from './application-setup-connectors/application-setup-connectors.page';
import { ApplicationSetupConsumerPage } from './application-setup-consumer/application-setup-consumer.page';
import { ApplicationSetupFirstPage } from './application-setup-first/application-setup-first.page';
import { ApplicationSetupNextPage } from './application-setup-next/application-setup-next.page';
import { useApplicationSetup } from './application-setup.hook';

export const ApplicationSetupPage = () => {
  const { name } = useApplicationSetup();

  return (
    <>
      {name === RouteEnum.ApplicationSetup.name && <ApplicationSetupFirstPage />}
      {name === RouteEnum.ApplicationSetupConnectors.name && <ApplicationSetupConnectorsPage />}
      {name === RouteEnum.ApplicationSetupConsumer.name && <ApplicationSetupConsumerPage />}
      {name === RouteEnum.ApplicationSetupNext.name && <ApplicationSetupNextPage />}
    </>
  );
};
